import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-obs-social-audit',
  templateUrl: './obs-social-audit.component.html',
  styleUrls: ['./obs-social-audit.component.css'],
})
export class ObsSocialAuditComponent implements OnInit {
  searchText = '';
  loading = false;
  url = 'socialAuditEvents';

  data: Array<any> = [];
  filteredData: Array<any> = [];

  activeSection:
    | 'overview'
    | 'incidents'
    | 'root-cause'
    | 'safe-states'
    | 'recovery-actions' = 'overview';

  incidentsCreated: number = 0;
  safeStatesActivated: number = 0;
  recoveryActions: number = 0;
  avgDurationMinutes: number = 0;

  topRootCauses: { reason: string; count: number }[] = [];
  auditLog: any[] = [];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.dataService.getData(this.url + '?limit=100').subscribe(
      (response: any) => {
        if (response && response.rst && response.data) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.applyMetrics();
        } else {
          this.messageService.add(
            response.msg || 'No se pudo cargar la data de Auditoría',
            'secondary',
          );
        }
        this.loading = false;
      },
      (error: any) => {
        this.messageService.add('Error al conectar con Auditoría', 'danger');
        this.loading = false;
        console.error(error);
      },
    );
  }

  applyMetrics() {
    this.auditLog = this.filteredData;

    // Safe states activados
    this.safeStatesActivated = this.filteredData.filter(
      (e) => e.event_name === 'safe_state_activated',
    ).length;

    // Incidentes (all degraded or incidents)
    this.incidentsCreated = this.filteredData.filter(
      (e) =>
        e.event_name === 'incident_created' ||
        e.event_name === 'health_degraded',
    ).length;

    // Recovery Actions
    this.recoveryActions = this.filteredData.filter(
      (e) =>
        e.event_name === 'recovery_action_triggered' ||
        e.event_name === 'safe_state_deactivated',
    ).length;

    // Duration calculation mock (based on payload if available)
    let totalDur = 0;
    let durCount = 0;
    this.filteredData.forEach((e) => {
      if (e.payload?.duration_minutes) {
        totalDur += e.payload.duration_minutes;
        durCount++;
      }
    });
    this.avgDurationMinutes =
      durCount > 0 ? Math.round(totalDur / durCount) : 0;

    // Root Cause distribution
    const causesMap: { [key: string]: number } = {};
    this.filteredData.forEach((e) => {
      const reason = e.reason_code || 'Unknown';
      if (
        e.event_name === 'incident_created' ||
        e.event_name === 'health_degraded' ||
        e.event_name === 'safe_state_activated'
      ) {
        causesMap[reason] = (causesMap[reason] || 0) + 1;
      }
    });

    this.topRootCauses = Object.entries(causesMap)
      .map(([reason, count]) => ({ reason, count }))
      .sort((a, b) => b.count - a.count);
  }

  filterInfo() {
    const text = this.searchText.trim().toLowerCase();
    if (!text) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter(
        (item) =>
          item.event_name?.toLowerCase().includes(text) ||
          item.entity_type?.toLowerCase().includes(text) ||
          item.reason_code?.toLowerCase().includes(text) ||
          item.triggered_by_type?.toLowerCase().includes(text),
      );
    }
    this.applyMetrics();
  }

  setSection(section: typeof this.activeSection) {
    this.activeSection = section;
  }

  totalRootCausesCount(): number {
    return this.topRootCauses.reduce((acc, curr) => acc + curr.count, 0);
  }

  getEventIcon(eventName: string): string {
    if (eventName.includes('safe_state'))
      return 'fas fa-shield-alt text-primary';
    if (eventName.includes('incident') || eventName.includes('degraded'))
      return 'fas fa-exclamation-triangle text-danger';
    if (eventName.includes('recovery')) return 'fas fa-tools text-success';
    return 'fas fa-info-circle text-secondary';
  }
}
